/** Returns `word` with a trailing "s" unless `count` is exactly 1. */
export function pluralize(count, word) {
  return `${word}${count === 1 ? '' : 's'}`;
}
